import Switch from "@mui/material/Switch";
const STATUS_COLORS = {
  active: "success",
  connected: "success",
  approved: "success",
  pending: "warning",
  inactive: "secondary",
  error: "danger",
  failed: "danger",
};

const statusColor = (status) =>
  STATUS_COLORS[String(status || "").toLowerCase()] || "secondary";

const StoreCard = ({ store, busy, onToggle, onOpen }) => {
  return (
    <div
      className={`card h-100 border-0 shadow-sm ${store.isActive ? "" : "opacity-75"}`}
      role="button"
      tabIndex={0}
      onClick={() => onOpen(store.id)}
      onKeyDown={(e) => e.key === "Enter" && onOpen(store.id)}
      style={{ cursor: "pointer" }}
    >
      <div className="card-body d-flex flex-column">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <span
            className={`badge rounded-pill text-bg-${
              store.type === "source" ? "primary" : "info"
            } text-capitalize`}
          >
            <i
              className={`bi ${
                store.type === "source"
                  ? "bi-box-arrow-in-down"
                  : "bi-box-arrow-up"
              } me-1`}
            />
            {store.type}
          </span>

          {/* stop the click from opening the details page */}
          <div onClick={(e) => e.stopPropagation()}>
            <Switch
              size="small"
              checked={!!store.isActive}
              disabled={busy}
              onChange={() => onToggle(store)}
              inputProps={{ "aria-label": `Toggle ${store.public_name}` }}
            />
          </div>
        </div>

        <h6
          className="fw-semibold mb-1 text-truncate"
          title={store.public_name}
        >
          {store.public_name || "Unnamed store"}
        </h6>

        <div className="mt-auto pt-3 d-flex justify-content-between align-items-center">
          <span
            className={`badge bg-${statusColor(store.status)}-subtle text-${statusColor(
              store.status,
            )}-emphasis text-capitalize`}
          >
            {store.status || "unknown"}
          </span>
          <span className="small text-primary">
            Details <i className="bi bi-arrow-right" />
          </span>
        </div>
      </div>
    </div>
  );
};
export default StoreCard;
